var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDlc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDlc0)",
    fillRule: "evenodd",
    d: "M6.857 5.974v3.9l1.256 1.543l-1.256 1.92v4.693c0 .223.18.403.399.403h5.73c.309-.004 5.871-.326 5.871-6.261c0-4.74-3.668-6.6-5.875-6.6H7.26a.403.403 0 0 0-.403.402m.858 3.322l.938 1.307l.814-1.449A.28.28 0 0 1 9.712 9h5.438c.099 0 .189.056.236.137l1.341 2.156a.27.27 0 0 1-.021.3l-3.849 4.95a.43.43 0 0 1-.317.176a.42.42 0 0 1-.325-.172L8.657 12.16l-.942 1.47v3.673c0 .15.12.27.27.27h4.984c1.676-.06 5.031-1.256 5.031-5.55c0-4.29-3.355-5.516-5.031-5.593H7.985a.27.27 0 0 0-.27.27zm4.191.561l-.831 1.286H9.296l.729-1.286zm-2.357 1.715l2.143 2.914l-.652-2.915zm5.228-1.715H12.9l.832 1.286h1.774zm.48 1.715l-2.142 2.982l.647-2.982h1.5zm-3.651-.429h1.577l-.78-1.286zm1.689.428h-1.8l.908 3.643z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDlc0",
    x1: 6.857,
    x2: 18.857,
    y1: 12.002,
    y2: 12.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16E0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14C5D7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlc);
export default __webpack_public_path__ + "static/media/dlc.83e964ebb0238f9958f20113c454306d.svg";
export { ForwardRef as ReactComponent };